import React from 'react';
import Icon from '../Icon/Icon';
import { toast } from 'react-toastify';
import styles from './Toast.module.scss';
import cx from 'classnames';
import Spinner from '../../../common/components/Spinner';

export const ToastNotification = ({
  message,
  iconName = false,
  isMobileView,
  spinner = false,
  Child = null,
  toastId = null,
  onClose = null,
  timeout = null,
  draggable = true,
  draggablePercent = 50,
  autoClose = true,
}) => {
  return toast(
    <>
      {Child ? (
        Child
      ) : (
        <>
          {spinner && <Spinner width="40px" height="40px" size="3px" className={styles.spinnerIcon} />}
          {iconName && <Icon src={iconName} className={cx(styles.icon)} />}
          <div className={styles.toastTextContainer}>
            <span className={styles.textToast}>{message}</span>
            <Icon src="close" className={styles.toastCloseIcon} />
          </div>
        </>
      )}
    </>,
    {
      position: isMobileView ? 'bottom-right' : 'top-right',
      className: styles.toastContainer,
      contentClassName: styles.toastContainer,
      bodyClassName: styles.toastBody,
      closeButton: false,
      toastId: toastId,
      onClose: onClose,
      draggable: draggable,
      draggablePercent: draggablePercent,
      ...(timeout ? { autoClose: timeout } : {}),
      ...(autoClose ? {} : { autoClose: false }),
    }
  );
};
